import React, { useEffect, useMemo, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import { ConsultaTotvsEmpresa, ConsultaTotvsEmpresaIndividual } from "../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import SelectFixo from "../../../components/SelectFixo";

import Solicitacao from "../../../../lib/json/consultas/Solicitacao.json"
import SelectUsuario from "../../../components/Select/Usuario";
import SelectEmpresa from "../../../components/Select/Empresa";
import SelectCentroCusto from "../../../components/Select/CentroCusto";
import SelectComprador from "../../../components/Select/Comprador";
import { ErroMsg, RetornaUsuarioLogado, SucessoMsg, formatDateColumn, formatarComoDecimal, formatarComoMoeda, formatarMoeda2, optionsStatusSC } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { format, startOfMonth, startOfYear } from "date-fns";
import { usePopUp } from "../../../components/BootBox";
import { handleNumeroItemSCColumn, handlePrioridadeSCColumn, handleProdutoSCColumn, handleQtdValorSCColumn, handleStatusSC } from "../../../components/GridCell/Solicitacao";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";
import ExportarExcel from "../../../components/ExportarExcel";

function ListaSolicitacaoCompra(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = Solicitacao.tabelas;
    
    const navigate = useNavigate();
    const currentDate = new Date()
    const firstDayOfMonthDate = startOfMonth(currentDate);
    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus

    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [consulta, setConsulta] = useState();
    const [empresa, setEmpresa] = useSessionStorageState("solicitacaoEmpresa",{value: '', text: ''});
    const [solicitacao, setSolicitacao] = useSessionStorageState("solicitacaoNumero",'');
    const [dateDe, setDateDe] = useSessionStorageState("solicitacaoDataDe", format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useSessionStorageState("solicitacaoDataAte", format(currentDate, 'yyyy-MM-dd'));
    const [campoSolicitante, setCampoSolicitante] = useSessionStorageState("solicitacaoSolicitante",usuarioProtheus);
    const [campoComprador, setCampoComprador] = useSessionStorageState("solicitacaoComprador",{value: usuarioProtheus?.value || '', label: ''});
    const [campoCentroCusto, setCampoCentroCusto] = useSessionStorageState("solicitacaoCentroCusto",null);
    const [campoStatus, setCampoStatus] = useSessionStorageState("solicitacaoStatus", optionsStatusSC[0]);
    const [disabledSolicitante, setDisabledSolicitante] = useState(!usuarioLogado.permissao.visualizarSolicitacao)
    const [disabledComprador, setDisabledComprador] = useState(false)

    const regraAux = usuarioLogado.parametrosEmpresas.map( (item) => {
        return `( row.original.EMPRESA + '' + row.original.C1_FILIAL.substr(0,2) === '${item.empresaFilial}' ` + ( item.incluirSolicitacao ? `` : `  && row.original.C1_USER === '${usuarioProtheus.value}' `) + ')';
    })
    const regraAuxLimpo = regraAux.filter( (item) => item !== '' )
    const regraAdicional = regraAuxLimpo.length > 0 ? ` && (${regraAuxLimpo.join(' || ')}) ` : '';

    var empresaCopiar = {value: '', text: ''};
    var scOrigem = '';
    var empresaOrigem = '';

    const excelColumns = [
        {
            Header: 'Filial',
            accessor: "C1_FILIAL",
        },
        {
          Header: 'Solicitação',
          accessor: "C1_NUM",
        },
        {
          Header: 'Item',
          accessor: "C1_ITEM",
        },
        {
          Header: 'Prioridade',
          accessor: 'C1_XFLUXSC',
          Cell: handlePrioridadeSCColumn
        },
        {
          Header: 'Finalidade',
          accessor: 'DHK_DESCR',
        },
        {
          Header: 'Produto/Serviço',
          accessor: "C1_PRODUTO",
        },
        {
          Header: 'Nome Produto/Serviço',
          accessor: "DESCRI",
        },
        {
          Header: 'Quantidade',
          accessor: 'C1_QUANT',
          Cell: (item) => { return formatarComoDecimal(item.value, 4)}
        },
        {
          Header: 'Custo Meta - Unitário',
          accessor: 'C1_PRECO',
          Cell: (item) => { return formatarComoMoeda(item.value, 4)}
        },
        {
          Header: 'Custo Meta - Total',
          accessor: 'C1_TOTAL',
          Cell: (item) => { return formatarComoMoeda(item.value)}
        },            
        {
          Header: 'Emissão',
          accessor: 'C1_EMISSAO',
          Cell: formatDateColumn,
        },
        {
          Header: 'Previsão',
          accessor: 'NECESSIDADE',
          Cell: formatDateColumn,
        },
        {
          Header: 'Aprovação',
          accessor: 'C1_XDTAPRV',
          Cell: formatDateColumn,
        },
        {
          Header: 'Solicitante',
          accessor: 'C1_SOLICIT',
        },
        {
          Header: 'Centro Custo',
          accessor: 'C1_CC',
        },
        {
          Header: 'Descrição Centro Custo',
          accessor: 'CTT_DESC01',
        },
        {
          Header: 'Comprador',
          accessor: 'C1_CODCOMP',
        },
        {
          Header: 'Nome Comprador',
          accessor: 'Y1_NOME',
        },
        {
          Header: 'Descrição Complementar',
          accessor: 'C1_OBS',
        },
        {
          Header: 'CA',
          accessor: 'C1_XCA',
        },
        {
          Header: 'Endereço Entrega',
          accessor: 'C1_XENDENT',
        },
        {
          Header: 'Status',
          accessor: '',
          Cell: handleStatusSC
        },
        {
          Header: 'Cotação',
          accessor: "C1_COTACAO",
        },
        {
          Header: 'Pedido',
          accessor: "C1_PEDIDO",
        },
    ]
    

    // Colunas do grid
    const columns = [
        {
          Header: 'SC',
          accessor: "C1_NUM",
          Cell: (item) => handleNumeroItemSCColumn(item, DisparaBootBox, FechaBootBox, navigate),
          style: { width: '10%!important' },
        },
        {
          Header: 'Produto/Serviço',
          accessor: "C1_PRODUTO",
          Cell: handleProdutoSCColumn,
          style: { width: '25%!important' },
        },
        {
          Header: 'Qtde. / Custo Meta',
          accessor: 'C1_QUANT',
          Cell: handleQtdValorSCColumn,
          style: { width: '15%!important' },
        },
        {
          Header: 'Emissão',
          accessor: 'C1_EMISSAO',
          Cell: formatDateColumn,
          style: { width: '10%!important' },
        },
        {
          Header: 'Previsão',
          accessor: 'NECESSIDADE',
          Cell: formatDateColumn,
          style: { width: '10%!important' },
        },
        {
          Header: 'Status',
          accessor: '',
          Cell: handleStatusSC
        }
    ];

    // WHERE/filtros da consulta do grid
    const retornaConsultaDefault = () => {
        const consultaSolic = Solicitacao.consulta;
        const posicao = consultaSolic.search(/\bFROM\b/i);
        var consultaDefault = `SELECT [EMPRESA] EMPRESA, 
                                    C1_FILIAL, C1_NUM, C1_ITEM, C1_XFLUXSC, DHK_DESCR, C1_PRODUTO, CASE WHEN B5_CEME != '' THEN B5_CEME ELSE C1_DESCRI END AS DESCRI, 
                                    C1_QUANT, C1_PRECO, C1_TOTAL, C1_EMISSAO, C1_TIPCOM,
                                    CONVERT(VARCHAR(8), CASE WHEN C1_XDTAPRV <> '' THEN DATEADD(DAY, DATEDIFF( DAY, CONVERT(DATE, C1_EMISSAO, 112), CONVERT(DATE, C1_DATPRF, 112)), CONVERT(DATE, C1_XDTAPRV, 112)) ELSE CONVERT(DATE, C1_DATPRF, 112) END , 112) NECESSIDADE,
                                    ISNULL(PS1_LIBDT, C1_XDTAPRV) C1_XDTAPRV, 
                                    C1_SOLICIT, C1_CC, CTT.CTT_DESC01, C1_CODCOMP, Y1_NOME,
                                    C1_OBS, C1_XCA, C1_XENDENT,
                                    IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) C1_COTACAO, 
                                    C1_PEDIDO,
                                    IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) C1_QUJE, 
                                    IIF(PS1_STATUS IN ('000','007'), 'B', IIF(PS1_STATUS IN ('008','011','013'), 'R', C1_APROV)) C1_APROV, 
                                    IIF(PS1_STATUS = '012', 'S', C1_RESIDUO ) C1_RESIDUO, 
                                    C1_XMOTIV, C1_FLAGGCT, C1_USER ` 
            + (posicao !== -1 ? consultaSolic.substring(posicao) : "");

         
        
        consultaDefault += "AND C1_FILIAL = FILIAL(SC1) ";
        
        if(solicitacao) {
            consultaDefault += "AND C1_NUM = '"+solicitacao+"' ";
        }
        if(dateDe) {
            consultaDefault += "AND C1_EMISSAO >= '"+dateDe.replaceAll('-','')+"' ";
        }
        if(dateAte) {
            consultaDefault += "AND C1_EMISSAO <= '"+dateAte.replaceAll('-','')+"' ";
        }
        if(campoSolicitante?.value) {
            consultaDefault += "AND C1_USER = '"+campoSolicitante.value+"' ";
        }
        if(campoComprador?.value) {
            consultaDefault += "AND Y1_USER = '"+campoComprador.value+"' ";
        }
        if(campoCentroCusto) {
            const filtroCC = campoCentroCusto.map((item) => item.value).join("','")
            if (filtroCC){
                consultaDefault += "AND C1_CC IN ('"+filtroCC+"') ";
            }
        }
        if(campoStatus?.filtroSQL) {
            consultaDefault += "AND "+campoStatus.filtroSQL+" ";
        }
        
        consultaDefault += "ORDER BY C1_FILIAL, C1_NUM, C1_ITEM ";
        //Implementar Regra Filtragem Empresa x CC

        return consultaDefault
    }

    // Processa consulta do grid
    const listaSC = async () => {
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, empresaFilial );
        
        if (retConsulta.error === '00'){
            setData(retConsulta.data);
        }

        setCarregar(false);
    }

    useEffect( () => {
        listaSC()
    },[])

    const options = optionsStatusSC

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.C1_NUM}/${row.original.C1_ITEM}/${row.original.EMPRESA}${row.original.C1_FILIAL}`)
    }
    
    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.values.C1_NUM}/${row.original.C1_ITEM}/${row.original.EMPRESA}${row.original.C1_FILIAL}`)
    }

    const handleCopiar = (row) =>{
        const idRow = row.original.C1_NUM;
        const Mensagem = ( <>
                <SelectEmpresa
                    campoEmpresa={empresaCopiar}
                    onChangeEmpresa={(e) => {empresaCopiar = e}}
                />
            </>
        )
        
        const buttonsRender = [
            { variant: 'primary', action: handleConfirmaCopiar, label: 'Confirmar' },
            { variant: 'secondary', action: FechaBootBox, label: 'Cancelar' }
        ]
        
        scOrigem = row.values.C1_NUM;
        empresaOrigem = row.original.EMPRESA + '' + row.original.C1_FILIAL;

        DisparaBootBox('Confirmar Copia para Filial Escolhida ?', Mensagem, buttonsRender, idRow, null)
    }

    const handleConfirmaCopiar = () => {  
        FechaBootBox()
        navigate(`./Copiar/${scOrigem}/${empresaOrigem}/${empresaCopiar.value}`)
    }
    
    const handleExcluir = async (row) => {
        const idRow = row.original.EMPRESA + '' + row.original.C1_FILIAL + '|' + row.original.C1_NUM + '|' + row.original.C1_ITEM;
        const Mensagem = `Tem certeza que deseja excluir a SC: ${row.original.C1_NUM + ' / Item: ' + row.original.C1_ITEM + ' - da Filial: ' + row.original.C1_FILIAL}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { 
            Numero: row.split('|')[1],
            Item: row.split('|')[2],
        }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('EXCLUIRSOLICITACAOCOMPRAS', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)                
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
            listaSC();
        }
    };

    const handleCancelar = async(row) =>{
        const cJSONSalvar = [{ 
            Numero: row.original.C1_NUM,
            Item: row.original.C1_ITEM,
            Status: "C",
            Motivo: ""
        }]
        const empresaFilial = row.original.EMPRESA + '' + row.original.C1_FILIAL

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('DEVOLVERSOLICITACAOCOMPRA', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
                listaSC();
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    }

    const excelHeaders = useMemo(() => {
        return excelColumns.map(col => col.Header);
    }, [excelColumns]);

    const excelRows = useMemo(() => {
        return data.map(item =>
            excelColumns.map(col => {
                const value = item[col.accessor];

                if (col.Cell) {
                    return col.Cell({ value, row: { original: item } });
                }
                return value ?? ""; // valor padrão se undefined/null
            })
        );
    }, [data, excelColumns]);

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Solicitação de Compras"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Solicitação"
                        tipo='text'
                        max="6"
                        value={solicitacao}  // Define o valor do campo com base no estado
                        onChange={(e) => setSolicitacao(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Emissão de"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Emissão até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectUsuario
                        campoUsuario={campoSolicitante}
                        onChangeUsuario={setCampoSolicitante}
                        disabled={disabledSolicitante}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectComprador
                        campoComprador={campoComprador}
                        changeComprador={setCampoComprador}
                        empresaLogada={empresa.value}
                        disabled={disabledComprador}
                    />
                </Col>                
                <Col md="4" xs="12">
                    <SelectCentroCusto 
                        campoCentroCusto={campoCentroCusto}
                        changeCentroCusto={setCampoCentroCusto}
                        empresaLogada={empresa.value}
                        isMultiplo={true}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectFixo 
                        options={options} 
                        value={campoStatus} 
                        selectedOptionValue={campoStatus}
                        isLabel={true} 
                        label="Status" 
                        onChange={(e) => setCampoStatus(e)}
                        />
                </Col>
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaSC}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
                <Col md="3" xs="12">
                    <ExportarExcel 
                        nomeArquivo="Solicitacao_Compra"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        linhaCondicional={(item) => item.C1_XFLUXSC === '3'}
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote", regraExclude: "!( ( (row.original.C1_APROV === 'R' || row.original.C1_APROV === 'D' || row.original.C1_APROV === 'B') || !( (row.original.C1_COTACAO.trim() !== '' || row.original.C1_PEDIDO.trim() !== '' || row.original.C1_RESIDUO === '' ) && row.original.C1_APROV === 'L' ) ) " + regraAdicional + ')'},
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger", regraExclude: "!( ( (row.original.C1_APROV === 'R' || row.original.C1_APROV === 'B') || !( (row.original.C1_COTACAO.trim() !== '' || row.original.C1_PEDIDO.trim() !== '' || row.original.C1_RESIDUO === '' ) && row.original.C1_APROV === 'L' ) ) " + regraAdicional + ')'},
                            {isExcluir: true, action: handleCancelar, label: "Cancelar", icone: "MdOutlineCancel", style: "danger", regraExclude: "!( (row.original.C1_APROV === 'D' ) " + regraAdicional + ')' }
                        ]}
                        paginacao={200}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaSolicitacaoCompra;
//{isAlterar: true, action: handleCopiar, label: "Copiar", icone: "MdOutlineCopyAll", style: "success"}, 
